<template>
  <div class="home py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.domain.create")}}</span>
    <div v-if="dataLoaded" class="form-container">
      <AveineDomainForm :APIbaseURL="APIbaseURL" :domain="domain" :invitation="invitation" :adminMode="true"/>
    </div>
    <div v-else class="d-flex justify-center align-center mt-16">
      <v-progress-circular
        indeterminate
        :size="100"
        :width="10"
        color="secondary"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { AveineDomainForm } from 'aveine-domain'
import { Domain, Invitation } from 'aveine-toolbox'
export default {
  data () {
    return {
      domain: {},
      invitation: {},
      dataLoaded: false,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  name: 'Create',
  components: {
    AveineDomainForm
  },
  async created() {
    this.domain = await Domain.new();
    this.invitation = await Invitation.new();

    this.domain.$isNew = true;
    this.invitation.$isNew = true;
    this.dataLoaded = true;
  },
}
</script>
